<template>

  <div>  <ob-modal2 style="display: flex ;flex-direction: column ;; align-items: center;" :show.sync="showElectronicSignPopUp"
    :type="1">
    <div class="electronicSignWarning-body" style="padding-bottom: 20px;">
      <img style="width: 80px;" :src="`${CDNIMAGESBASEURL}/hrspa/Content/Images/Admin_settings/Warning.svg`
        " width="65" />
      <div style="    font-size: 24px;color: #FF0000;">
        Electronic Signature Warning
      </div>
      <div style="    text-align: center; font-size: 14px;">
        Some universities do not accept electronic signatures.Please check with
        your employee or the concerned university before proceeding.
      </div>
      <div>
        <ob-checkbox class="checkbox-in" v-model="consentAvailable">
          I have confirmed with the concerned parties and accept full
          responsibility for proceeding with this option.</ob-checkbox>
      </div>
    </div>
    <div class="modal-soc--footer" style="padding: 0px 20px 20px 20px;text-align:center;">
      <ob-button type="secondary" @click="handleCancelElectronicsignPopUp">Cancel</ob-button>
      <ob-button type="primary" @click="onProceedAnyway" :disabled="!consentAvailable">Proceed Anyway</ob-button>
    </div>
  </ob-modal2>
</div>
</template>

<script>
export default {
  props: ["openModalWarning", "ConsentAvailable", "ProceedtoInitiate"],
  data() {
    return {
      showElectronicSignPopUp: true,
      consentAvailable: true,
      proceed: false,
      test: false,
    };
  },
  created() {
    this.showElectronicSignPopUp = this.openModalWarning;
  },
  watch: {
    openModalWarning(val) {
      if (val) this.showElectronicSignPopUp = val;
    },
    consentAvailable(val) {
      this.$emit("update:ConsentAvailable", val);
    },
  },
  mounted() {
    this.consentAvailable = false;
  },
  beforeDestroy() {
    this.consentAvailable = false, 
    this.proceed = false
  },
  methods: {
    onProceedAnyway() {
      debugger;
      this.$emit("update:ConsentAvailable", this.consentAvailable);
      this.$emit("update:ProceedtoInitiate", true);
      this.proceed = false, 
      this.$emit("update:openModalWarning", false);
    },
    handleCancelElectronicsignPopUp() {
      this.$emit("update:ConsentAvailable", false);
      this.$emit("update:openModalWarning", false);
      this.showElectronicSignPopUp = false;
    },
  },
};
</script>
<style>
.ElectronicPopUP-body {
  width: 600;
  height: 422;
  display: flex;

  justify-content: space-evenly;
}

.electronicSignWarning-body {
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;

  gap: 16px;
  padding-top: 56px;
  padding-right: 32px;
  padding-bottom: 56px;
  padding-left: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/FormI983/ElectronicSignWarningPopUp.vue